import { render, staticRenderFns } from "./BoxSelectionModal.vue?vue&type=template&id=58d5970c&scoped=true&"
import script from "./BoxSelectionModal.vue?vue&type=script&lang=js&"
export * from "./BoxSelectionModal.vue?vue&type=script&lang=js&"
import style0 from "./BoxSelectionModal.vue?vue&type=style&index=0&id=58d5970c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d5970c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\employee-listing\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58d5970c')) {
      api.createRecord('58d5970c', component.options)
    } else {
      api.reload('58d5970c', component.options)
    }
    module.hot.accept("./BoxSelectionModal.vue?vue&type=template&id=58d5970c&scoped=true&", function () {
      api.rerender('58d5970c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "EmployeeListing/components/BoxSelectionModal.vue"
export default component.exports